export type PwaNotificationSettings = {
  streamOnline: boolean;
  streamOffline: boolean;
};

export const defaultPwaNotificationSettings: PwaNotificationSettings = {
  streamOnline: false,
  streamOffline: false,
};

export const normalizePwaNotificationSettings = (
  config?: Partial<PwaNotificationSettings> | null,
): PwaNotificationSettings => ({
  streamOnline: Boolean(config?.streamOnline),
  streamOffline: Boolean(config?.streamOffline),
});

export type ServerPwaConfig = {
  notifications?: Partial<PwaNotificationSettings>;
  push?: {
    publicKey?: string;
  };
};
